import RegisterForm from "./registerForm";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const RegisterPageWrapper = (props) => {
    return (
        <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}>
            <RegisterForm {...props}/>
        </GoogleReCaptchaProvider>
    );
};

export default RegisterPageWrapper;
